module.exports = __webpack_public_path__ + "img/Invezt-01.e6111283.svg";